export default __webpack_public_path__ + "static/fv_company_logo-a9843c1bee6e0bd442a6e5e3e6feb2d9.png";